/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Assignee/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TasksAssignee from 'DesignSystem/TasksAssignee/index'



/** @type {import('Simple/types.js').View} */
export default function Assignee({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/TaskInsertNew/Assignee",
  onChange
  
}) {
let selectedDataNewTaskAssigneeValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'data.new_task.assignee',
})
let selectedDataNewTaskAssigneeChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'data.new_task.assignee',
})
  return (<React.Fragment
>
<TasksAssignee
  viewPath={`${viewPath}/TasksAssignee`}
 data="selected.data.new_task.assignee"
 assignee_id={selectedDataNewTaskAssigneeValueData}
 onChange={selectedDataNewTaskAssigneeChangeData}
/>
{children}
</React.Fragment>)
}